/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ArrayUtil from "../../Utils/ArrayUtil";
import AppSnackbarItem from "./AppSnackbarItem";

const TYP_BEZEICHNUNG_INDICATOR = "_";
const FELD_BEZEICHNUNG_START = 1;
export const PATH_WILDCARD = "*";

const enthaeltTypBezeichnung = (path: string[]) => {
    if (ArrayUtil.isEmpty(path)) {
        return false;
    }

    return path[0].includes(TYP_BEZEICHNUNG_INDICATOR);
};

const entferneTypBezeichnung = (path: string[]) => {
    return enthaeltTypBezeichnung(path) ? path.slice(FELD_BEZEICHNUNG_START) : path;
};

const normalize = (path1: string[], path2: string[]) => {
    if ([path1, path2].every(enthaeltTypBezeichnung)) {
        return [path1, path2];
    }

    return [entferneTypBezeichnung(path1), entferneTypBezeichnung(path2)];
};

export const pathFrom = (typBezeichnung: string | undefined, feldBezeichnung: string | string[]) => {
    return [
        ...(typeof typBezeichnung === "undefined" ? [] : [typBezeichnung]),
        ...(Array.isArray(feldBezeichnung) ? feldBezeichnung : [feldBezeichnung]),
    ];
};

export const pathEquals = (pathA: string[], pathB: string[]) => {
    if (pathA.length !== pathB.length) {
        return false;
    }

    return pathA.every((path, index) => path.toLowerCase() === pathB[index].toLowerCase() || path === PATH_WILDCARD || pathB[index] === PATH_WILDCARD);
}

export const isPathMatching = (item: AppSnackbarItem, path: Array<string>) => {
    const [serverValidationPath, uiValidationPath] = normalize(item.path, path);
    return pathEquals(serverValidationPath, uiValidationPath);
};
